import { EVENTS, MODALS } from 'common/domain/constants';
import { isUndefinedOrNullOrEmpty } from 'common/utils/isUndefinedOrNullOrEmpty';
import TeamRequestsListAssembler from './teamRequestsList/teamRequestsList.assembler';
import { VA_TEAM_REQUESTS_MODAL_COACHMARK_CONFIG } from 'vacations-absences.module/common/domain/constants';

class TeamRequestsController {
  constructor(
    $window,
    $rootScope,
    teamRequestsService,
    vacationUserDataService,
    $log,
    vacationDelegationService,
    vacationsAbsencesService,
    loadingMobileService
  ) {
    'ngInject';
    this.teamRequestsService = teamRequestsService;
    this.vacationsAbsencesService = vacationsAbsencesService;
    this.rootScope = $rootScope;
    this.window = $window;
    this.log = $log;
    this.teamRequestsListAssembler = new TeamRequestsListAssembler();
    this.loaded = false;
    this.managerId = vacationUserDataService.getEmployee().userId;
    this.nextId = 0;
    this.coachmarkData = VA_TEAM_REQUESTS_MODAL_COACHMARK_CONFIG;
    this.vacationDelegationService = vacationDelegationService;
    this.loadingMobileService = loadingMobileService;
    this.isMobileApp = $window.innerWidth < 1024;
  }

  $onInit() {
    this._loadData();
    this._resetApproveAllModalState();
    this.vacationDelegationService.hasDelegated(this.managerId).then(response => {
      this.hasDelegations = response.hasDelegated;
    });
  }

  isDisabled() {
    return this.isWageInProcess;
  }

  _loadData() {
    this.loadingMobileService.show();
    this.loaded = false;
    this.vacationsAbsencesService._loadTeamRequestData().then(() => {
      this.requests = this.vacationsAbsencesService.TeamRequestDataService.getData();
      const requestsNumber = this.requests.length;
      this.rootScope.$broadcast(EVENTS.BADGE_NUMBER, {badgeNumber: requestsNumber});
      this.employees = [];

      if (!isUndefinedOrNullOrEmpty(this.requests)) {
        this.employees = this.teamRequestsListAssembler.buildListFromRequestList(this.requests);
      }

      this.loaded = true;
      this.loadingMobileService.hide();
    });
  }

  _resetApproveAllModalState() {
    $(MODALS.TEAM_REQUESTS.APPROVE_ALL).on('hidden.bs.modal', () => {
      this.approveAllSuccess = null;
      this.approveAllError = null;
    });
  }

  confirmApproveAll($event) {
    this.requestsForApproveAll = $event.requests;
    $(MODALS.TEAM_REQUESTS.APPROVE_ALL).modal('show');
  }

  approveAll() {
    this.loadingMobileService.show();
    return this.teamRequestsService.approveAll(this.managerId, this.requestsForApproveAll).then(() => {
      this.approveAllSuccess = true;
      this.requestsForApproveAll.forEach((approved) => {
        this.requests = this.requests.filter(request => request !== approved);

        if (this.isMobileApp) {
          const requestsNumber = this.requests.length;
          this.rootScope.$broadcast(EVENTS.BADGE_NUMBER, {badgeNumber: requestsNumber});
        }

        this.loadingMobileService.hide();
      });
    }, (error) => {
      this.approveAllError = error;
      this.loadingMobileService.hide();
    });
  }
}

export default TeamRequestsController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequests.controller.js